import { render, staticRenderFns } from "./option-fee-received.vue?vue&type=template&id=edd65ce4"
import script from "./option-fee-received.vue?vue&type=script&lang=js"
export * from "./option-fee-received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports